import "whatwg-fetch"
import "babel-polyfill"

export const onClientEntry = () => {
  // Don't need to do anything here, but if you don't
  // export something, the import won't work.
}
